module.exports = __webpack_public_path__ + "static/media/momky.8f8a96f4.png";